<template>
  <div>
    <el-dialog
      :visible="isShow"
      title="发货产品清单"
      width="1000px"
      class="partShipment"
      @close="handelClose"
    >
      <el-table
        :data="tableData"
        border
      >
        <el-table-column prop="invoiceNumber" label="ERP发货单号" align="left" />
        <el-table-column prop="erpOrderNumber" label="订单编号" align="left" />
        <el-table-column prop="porductCode" label="物品代码" align="left" />
        <el-table-column prop="productName" label="产品名称" align="left" />
        <el-table-column prop="number" label="数量" align="left" />
        <el-table-column prop="productUnit" label="单位" align="left" />
        <el-table-column prop="materialObject" label="是否实物" align="left">
          <template v-slot="{row}">
            {{ row.materialObject === 'Y' ? '是' : '否' }}
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button type="default" @click="handelClose">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getDeliveryDetails } from '@/API';
export default {
  data () {
    return {
      isShow: false,
      tableData: []
    };
  },

  methods: {
    initData (row) {
      // 'FH202101130350'
      getDeliveryDetails(
        row.masterContractNum,
        row.invoiceNum
      ).then(res => {
        const { data, status } = res.data;
        if (status === '200') {
          this.tableData = data.productList.map(item => {
            return {
              ...item,
              erpOrderNumber: data.erpOrderNumber
            };
          });
        }
      });
    },

    openDialog (row) {
      this.tableData = [];
      this.initData(row);
      this.isShow = true;
    },

    handelClose () {
      this.tableData = [];
      this.isShow = false;
    }
  }
};
</script>
